// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__11xel","overflowing":"ReadFullNote_overflowing__sb4Iu"};